import React from 'react';
import PropTypes from 'prop-types';

import { lighten } from '@mui/material/styles';

import Stack from '@mui/material/Stack';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

import ListIcon from '@mui/icons-material/List';

import PackingListExport from 'components/Shared/PackingListExport';


const ReclamationsRetourPlateformeTableToolbar = ({ numSelected, onClickOpenPackingList}) => {


    return (
        <Toolbar
            sx={theme => (numSelected > 0 ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85)
            } : null)}
        >

            <Typography variant="h6" id="tableTitle" component="div">
                Dossier après-vente avec retour plateforme attendu
            </Typography>

            <Stack direction="row" spacing={2} sx={{ marginLeft: 8 }}>

                <PackingListExport />

                {numSelected > 0 && (
                    <Stack>
                        <Typography color="inherit" variant="subtitle1" component="div">
                            {numSelected} {numSelected > 1 ? 'sélectionnés' : 'sélectionné'}
                        </Typography>

                        <Button
                            variant="contained"
                            color="secondary"
                            startIcon={<ListIcon />}
                            onClick={onClickOpenPackingList}
                        >
                            Générer&nbsp;la&nbsp;'Packing&nbsp;List'
                        </Button>
                    </Stack>
                )}

            </Stack>

        </Toolbar>
    );
}

ReclamationsRetourPlateformeTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired
};


export default ReclamationsRetourPlateformeTableToolbar;